<template>
  <div id="page-item">
    <div style="margin:10px;">
      <el-input
        prefix-icon="el-icon-search"
        :placeholder="$t('products.searchProducts')"
        clearable
        v-model="search"
        v-popover:popover>
        <el-dropdown slot="append" style="border-right:1px;">
            <el-button type="primary">
            <span class="hidden-md-and-down">{{ $t('products.sortBy') }}<i class="el-icon-arrow-down el-icon--right"></i></span>
            <span class="hidden-lg-and-up"><i class="el-icon-sort" /></span>
            </el-button>
            <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :icon="sortIcon('productName')" @click.native="sortBy('productName')">{{$t('products.sorting.name')}}</el-dropdown-item>
            <el-dropdown-item :icon="sortIcon('sku')" @click.native="sortBy('sku')">{{$t('products.sorting.sku')}}</el-dropdown-item>
            <el-dropdown-item v-if="inventory!=null && inventory.delay_management"  :icon="sortIcon('age')" @click.native="sortBy('age')">{{$t('products.sorting.daysElapsed')}}</el-dropdown-item>
            <el-dropdown-item :icon="sortIcon('quantities.inStock')" @click.native="sortBy('quantities.inStock')">{{$t('products.sorting.availableQuantity')}}</el-dropdown-item>
            <el-dropdown-item :icon="sortIcon('provider')" @click.native="sortBy('provider')">{{$t('products.sorting.provider')}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        <el-button
          slot="prepend"
          @click="showFilters=true">
          <i class="mdi mdi-filter-variant" style="font-size:15px;">
            <span v-if="getNbFiltersCriteria>0">{{getNbFiltersCriteria}}
              <span class="hidden-md-and-down">
                <span v-if="getNbFiltersCriteria==1">{{$t('products.filters.filter')}}</span>
                <span v-else>{{$t('products.filters.filters')}}</span>
                <span v-if="getNbFiltersCriteria==1"> {{$t('products.filters.apply')}}</span>
                <span v-else> {{$t('products.filters.applys')}}</span>
              </span>
              <el-link type="info" @click="resetFilters" class="ml-2">
                <i class="mdi mdi-filter-remove"/>
              </el-link>
            </span>
            <span v-else class="secondary-text fs-14"> <span class="hidden-md-and-down">{{$t('products.filters.advancedFilters')}}</span></span>
          </i>
        </el-button>
      </el-input>
    </div>
    <div class="flex center m-10">
      <div class="box left secondary-text ml-10 fs-14">{{ nbProductsFound }} produit(s) trouvé(s)</div>
      <Pagination
        class="box right mt-5 mb-0 fs-14 secondary-text"
        :current-page="page"
        :total-number-of-page="pages"
        @click-previous="fetchPreviousPage"
        @click-next="fetchNextPage" />
    </div>
    <div class="box grow scrollable only-y item-list" :style="getHeightStyle" v-loading="loading" v-if="mode=='tile'">
      <!-- <div class="infinite-list" v-infinite-scroll="load" :infinite-scroll-distance="0" infinite-scroll-distance="200" style="overflow:auto;" :style="getHeightStyle"> -->
      <div v-for="(p, index) in products" :key="p.puid" style="margin:10px;" :class="{ active : active_el == p.puid }" @click="handleSelect(p,index)">
        <InventoryProductTile
          :product="p"
          :vintage="topVintage"
          :isFromPrivateImport="isFromPrivateImport"
          :isNegative="isNegative(p.quantity.nbDays,p.quantity.onHand)"
          :isIntermediary="isIntermediary(p.quantity.nbDays,p.quantity.onHand)"
          :isPositive="isPositive(p.quantity.nbDays,p.quantity.onHand)" />
      </div>
      <!-- </div> -->
    </div>
    <div v-else>
      <el-table
        :data="products"
        stripe
        :height="getHeight"
        :cell-style="{padding:'2px'}"
        :empty-text="$t('products.noProductsFound')"
        v-loading="loading"
        :style="'width:' + getTableWidth  + 'px'"
        >
        <el-table-column
          v-if="isFromPrivateImport"
          fixed="left"
          width="40"
          align="center">
          <template slot-scope="scope">
            <status-indicator v-if="scope.row.quantity.onHand > 0" :negative="isNegative(scope.row.quantity.nbDays, scope.row.quantity.onHand)" :intermediary="isIntermediary(scope.row.quantity.nbDays,scope.row.quantity.onHand)" :positive="isPositive(scope.row.quantity.nbDays,scope.row.quantity.onHand)" pulse/>
          </template>
        </el-table-column>
      <el-table-column
        prop="name"
        :label="$t('products.product')"
        width="500"
        fixed="left"
        v-if="showProductColumn"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <el-link type="primary" @click="handleSelect(scope.row,scope.$index)" class="fs-12">{{scope.row.extendedName}}</el-link>
        </template>
      </el-table-column>
      <el-table-column
        prop="provider.name"
        :label="$t('products.provider')"
        width="250"
        v-if="showProviderColumn"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <PortausLink :id="scope.row.provider.id" path="/customers/" :label="getProviderName(scope.row.provider)" v-if="scope.row.provider!=null" fs="fs-12"></PortausLink>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('products.typeSubtType')"
        width="200"
        v-if="showTypeColumn"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <Category :category="scope.row.category" :specificCategory="scope.row.specificCategory" />
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('products.tags')"
        width="200"
        v-if="showTagsColumn"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <el-tag  class="fs-12" size="mini" v-for="t in scope.row.tags" :key="t.id">{{t.code}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="scope.type"
        :label="$t('products.format')"
        v-if="showFormatColumn"
        width="150"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span class="fs-12">
            <span class="fs-12" v-if="scope.row.format!=null && scope.row.volume!=null">
              {{scope.row.volume}} {{getFormat(scope.row.format)}}
            </span>
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="scope.type"
        :label="$t('products.uvc')"
        width="120"
        v-if="showUVCColumn"

        :show-overflow-tooltip="true">
        <template slot-scope="scope">
            <UnitFormatVolumeLabel class="ml-5 fs-12" :unit="scope.row.unit" :uvc="scope.row.uvc"></UnitFormatVolumeLabel>
        </template>
      </el-table-column>
      <el-table-column

        v-if="showPriceColumn"
        :show-overflow-tooltip="true"
        width="100"
        :label="$t('products.price')">
        <template slot-scope="scope">
          <span v-if="!isFromPrivateImport">
            <span class="fs-12" v-if="scope.row.inventory.variableItemPriceInd == true">{{$n(batchAvailable(scope.row).price, 'currency')}}</span>
            <span class="fs-12" v-else>{{$n(scope.row.sellingUnitPrice, 'currency','CAD')}}</span>
          </span>
          <span v-else>
            <span class="fs-12" v-if="scope.row.agencyRate == null">
              {{$n(scope.row.sellingUnitPrice, 'currency','CAD')}}
            </span>
            <span v-else>
              <span class="fs-12" v-if="scope.row.pricing != null">
                {{$n(getPrice('LICENSEE', 'price', scope.row.pricing) + getPrice('LICENSEE', 'agencyFee', scope.row.pricing),'currency')}}
                <br>
                {{$n(getPrice('PARTICULIER', 'priceTaxIn', scope.row.pricing) + getPrice('PARTICULIER', 'agencyFeeWTaxes', scope.row.pricing),'currency')}}
              </span>
              <span class="fs-12" v-else></span>
            </span>

          </span>
        </template>
      </el-table-column>
      <el-table-column
        width="100"
        v-if="showPriceDetailColumn"
        :show-overflow-tooltip="true"
        :label="$t('products.detailledPrice')">
        <template slot-scope="scope" >
          <span v-if="!isFromPrivateImport">
            <span v-if="inventory.variableItemPriceInd == true" class="fs-12">{{$n(batchAvailable(scope.row).price, 'currency')}}</span>
            <span v-else class="fs-12">{{$n(scope.row.sellingUnitPrice, 'currency','CAD')}}</span>
          </span>
          <span v-else>
            <span v-if="scope.row.agencyRate == null" class="fs-12">
              {{$n(scope.row.sellingUnitPrice, 'currency','CAD')}}
            </span>
            <span v-else>
              <span class="fs-12" v-if="scope.row.pricing != null">
                {{$n(getPrice('LICENSEE', 'price', scope.row.pricing) + getPrice('LICENSEE', 'agencyFee', scope.row.pricing),'currency')}} ({{$n(getPrice('LICENSEE', 'price', scope.row.pricing),'currency')}}  + {{$n(getPrice('LICENSEE', 'agencyFee', scope.row.pricing),'currency')}}) +tx
                <br>
                {{$n(getPrice('PARTICULIER', 'priceTaxIn', scope.row.pricing) + getPrice('PARTICULIER', 'agencyFeeWTaxes', scope.row.pricing),'currency')}} ({{$n(getPrice('PARTICULIER', 'priceTaxIn', scope.row.pricing),'currency')}} + {{$n(getPrice('PARTICULIER', 'agencyFeeWTaxes', scope.row.pricing),'currency') + ')'}}
              </span>
              <span v-else></span>
            </span>

          </span>
        </template>
      </el-table-column>
      <el-table-column
       width="100"
        v-if="showAgencyFeeColumn"
        :show-overflow-tooltip="true"
        :label="$t('products.agencyFees')">
        <template slot-scope="scope" >
          <div v-if="scope.row.pricing!=null && scope.row.agencyRate!=null">
            <span class="fs-12" >
              {{ $n(getPrice('LICENSEE', 'agencyFee', scope.row.pricing), 'currency') }} +tx
            </span>
            <br>
            <span class="fs-12">
              {{ $n(getPrice('PARTICULIER', 'agencyFeeWTaxes', scope.row.pricing), 'currency') }}
            </span>
          </div>
          <span v-else> -- </span> 
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('products.daysElpasedSinceArrival')"
        :show-overflow-tooltip="true"
        v-if="showDelayColumn && isFromPrivateImport"
        width="100"
        align="center">
        <template slot-scope="scope">
          <span class="fs-12" v-if="showDelayColumn && inventory!=null && inventory.delay_management && scope.row.quantity.onHand > 0" >{{scope.row.quantity.nbDays}}</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('products.date150')"
        :show-overflow-tooltip="true"
        v-if="showDelayColumn && isFromPrivateImport"
        width="150"
        align="center">
        <template slot-scope="scope">
          <span class="fs-12" v-if="showDelayColumn && inventory!=null && inventory.delay_management" >{{showDelayDate(scope.row)}}</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('products.qty')"
        width="100"
        v-if="showQtyColumn"
        :show-overflow-tooltip="true"
        align="center">
        <template slot-scope="scope">
          <span class="align-vertical-middle fs-12" v-if="scope.row.quantity.inStock>0">{{scope.row.quantity.inStock}}</span>
          <span class="align-vertical-middle fs-12" v-else>0</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('products.inCommand')"
        width="100"

        v-if="showQtyInCommandColumn"
        :show-overflow-tooltip="true"
        align="center">
        <template slot-scope="scope">
          <span class="align-vertical-middle fs-12" v-if="scope.row.quantity.confirmed>0">{{scope.row.quantity.confirmed}}</span>
          <span class="align-vertical-middle fs-12" v-else>0</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('products.reserved')"
        width="100"

        v-if="showQtyReservedColumn"
        :show-overflow-tooltip="true"
        align="center">
        <template slot-scope="scope">
          <span class="align-vertical-middle fs-12" v-if="scope.row.quantity.reserved>0">{{scope.row.quantity.reserved}}</span>
          <span class="align-vertical-middle fs-12" v-else>0</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('products.reservedUpcmoning')"
        width="100"

        v-if="showQtyReservedNextBatchColumn"
        :show-overflow-tooltip="true"
        align="center">
        <template slot-scope="scope">
          <span class="align-vertical-middle fs-12" v-if="scope.row.quantity.reservedDelayed>0">{{scope.row.quantity.reservedDelayed}}</span>
          <span class="align-vertical-middle fs-12" v-else>0</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('products.inventory')"
        width="100"

        v-if="showQtyInventoryColumn"
        :show-overflow-tooltip="true"
        align="center">
        <template slot-scope="scope">
          <span class="align-vertical-middle fs-12" v-if="scope.row.quantity.onHand>0">{{scope.row.quantity.onHand}}</span>
          <span class="align-vertical-middle fs-12" v-else>0</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('products.inSupply')"
        width="100"

        v-if="showQtyToReceiveColumn"
        :show-overflow-tooltip="true"
        align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.quantity.pending>0" class="align-vertical-middle fs-12">
            {{scope.row.quantity.pending-scope.row.quantity.reservedDelayed}}
          </span>
          <span v-else class="fs-12">0</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('products.sold')"
        width="100"

        v-if="showQtySoldColumn"
        :show-overflow-tooltip="true"
        align="center">
        <template slot-scope="scope">
          <span class="align-vertical-middle fs-12" v-if="scope.row.quantity.ordered>0">{{scope.row.quantity.ordered}}</span>
          <span class="align-vertical-middle fs-12" v-else>0</span>
        </template>
      </el-table-column>
    </el-table>
    </div>
    <InventoryProductFilter :visible="showFilters" direction="ltr" @close="showFilters=false"></InventoryProductFilter>
  </div>

</template>
<script>

import { mapActions, mapState, mapGetters } from 'vuex';
import PortausUtil from '@/utils/portaus-utils';
import ProductUtil from '@/utils/product-util';
import PortausLink from '@/components/portaus-link'
import InventoryProductFilter from './inventory-product-filter'
import InventoryProductTile from './inventory-product-tile'
import UnitFormatVolumeLabel from '@/components/product/unitFormatVolumeLabel'
import Pagination from '@/components/pagination'
import CustomerUtil from '@/utils/customer-util'
import Category from '@/components/product/category-txt';
import dayjs from 'dayjs'

export default {
  name: 'Inventory-Product-List',
  props: {
		inventoryId : null
	},
  data() {
    return {
      columns: [],
      active_el : null,
      showFilters : false,
      icons : {
        'DESC' : 'el-icon-caret-bottom',
        'ASC' : 'el-icon-caret-top'
      },
      window: {
        width: 0,
        height: 0
      },
    };
  },components: {
    PortausLink,
    InventoryProductFilter,
    UnitFormatVolumeLabel,
    Pagination,
    InventoryProductTile,
    Category,
  },
	methods: {
    showDelayDate(product) {
      if (_.get(product, 'item.availabilityDate') != null && _.get(product, 'quantity.onHand') > 0) {
        return dayjs(_.get(product, 'item.availabilityDate')).add(150, 'day').format('YYYY-MM-DD');
      } 
      return '--';
    },
    getPrice(type, priceType, pricing) {
      let price = null;
      if (type === 'LICENSEE') {
        price = ProductUtil.getPriceByCustomerClass(pricing, this.licenseeCustomerClassId);
      } else if (type === 'PARTICULIER') {
        price = ProductUtil.getPriceByCustomerClass(pricing, this.particulierCustomerClassId);
      }

      return price[priceType];
      
    },
    getProviderName (provider) {
      return CustomerUtil.customerName(provider.name, provider.usualName);
    },
    showProductFilter(){
      this.showFilters = true;
    },
    closeProductFilter(){
      this.showFilters = false;
    },
    load($state) {
      if(this.page <= this.pages){
        this.fetchNextProductsPage()
          .then(()=>{
            if($state){
              $state.loaded();
            }
          })
      }else{
        if($state)$state.complete();
      }

    },
    unit(unit){
      return PortausUtil.getFormattedUnit_i18n(unit)
    },
    getFormat(format){
      if(format!=null&&format==1){
        return "ml";
      }else{
        return "l";
      }
    },
    handlePageChange(val){
      this.changePage(val);
    },
    handleSelect(p,index){
      this.active_el=p.puid;
      this.$emit('open',p,index)
    },
    sortBy(orderName){

      if(this.orderByModel.orderName!=orderName){
        this.orderByModel={orderName : orderName, direction:'ASC'};
        this.sortIconModel = this.icons['ASC'];
      }else{
        if(this.orderByModel.direction=='DESC'){
          this.orderByModel={orderName : orderName, direction:'ASC'};
          this.sortIconModel = this.icons['ASC'];
        }else{
          this.orderByModel={orderName : orderName, direction:'DESC'};
          this.sortIconModel = this.icons['DESC'];
        }
      }
    },
    batchAvailable(product){
      let prices = {
        price  : null,
        priceTaxIn : null
      };
      return _.get(product ,'item.prices') != null ? _.get(product ,'item.prices') : prices;
    },
    sortIcon(orderName){
      return orderName==this.orderBy.orderName?this.sort_icon:'';
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    ...mapActions('inventoryProducts',['fetchPreviousPage', 'fetchNextPage','setSearchTerms','setSortIcon','setOrderBy','changePage','fetchNextProductsPage', 'initDefaultColumns', 'resetFilters']),
    ...mapActions('controlData', ['fetchCustomerClasses'])
	},
	computed: {
    licenseeCustomerClassId () {
      return _.get(_.find(this.customerClasses, cc => cc.ind_agency_type === 'LICENCEE'), 'id');
    },
    particulierCustomerClassId () {
      return _.get(_.find(this.customerClasses, cc => cc.ind_agency_type === 'PARTICULIER'), 'id');
    },
    isFromPrivateImport () {
      if (this.inventory == null) return false;
      return _.get(this.inventory, 'code') === 'IP' ||  _.get(this.inventory, 'code') === 'PI';
    },
    orderByModel : {
      set(val){this.setOrderBy(val)},
      get(){return this.orderBy}
    },
    sortIconModel : {
      set(val){this.setSortIcon(val)},
      get(){return this.sort_icon}
    },
    search : {
        set(val){ this.setSearchTerms(val)},
        get(){return this.searchTerms}
    },
    getHeight(){
      return (this.window.height-280);
    },
    getTableWidth() {
      return (this.window.width-320);
    },
    getHeightStyle(){
      return "height:" + (this.window.height-245) + "px;";
    },
    ...mapGetters('inventoryProducts',['isPositive','isIntermediary','isNegative','providerName','showProductColumn','showProviderColumn', 'showTypeColumn','showTagsColumn','showFormatColumn','showUVCColumn','showPriceColumn','showPriceDetailColumn','showDelayColumn','showQtyColumn','showQtyToReceiveColumn','showAgencyFeeColumn', 'showQtyReservedColumn', 'showQtyReservedNextBatchColumn', 'showQtyInventoryColumn', 'showQtySoldColumn', 'showQtyInCommandColumn', 'getNbFiltersCriteria', 'nbProductsFound']),
    ...mapState('inventoryProducts', ['products', 'columnsOptions', 'orderBy','sort_icon','searchTerms','page','pages','limit','count','loading', 'mode','inventory','topVintage']),
    ...mapState('controlData', ['customerClasses']),
    ...mapGetters('inventory', ['getInventory']),
	},
  mounted(){
    this.fetchCustomerClasses();
  },
  watch: {
    // inventoryId : function(val){
    //   this.listInventoryProduct()
    //     .then(()=>{
    //       // this.loading=false;
    //       this.closeItem();
    //       this.item=null;
    //     })
    // }
  },
	created(){

    window.addEventListener('resize', this.handleResize)
    this.handleResize();
    this.initDefaultColumns();
	},
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/scss/_variables';


.active{
  background-color: lighten($background-color, 20%);
  border-radius: 5px;
  box-shadow:none;
  box-shadow: 0 4px 8px 0 rgba(40,40,90,.09),0 1px 3px 0 rgba(0,0,0,.065);
}


.item-list {
  //margin: 0 auto;
  width: 100%;
  padding: 0px 0px;
  box-sizing: border-box;

  .item {
    margin: 10px 0;
    padding: 5px;
    box-sizing: border-box;
    cursor: pointer;
    transition: all .5s .25s;


    .info {
      word-break: break-word;

    }

    &:hover {
      //margin: 15px -20px;
      //padding: 10px;
      background-color: lighten($background-color, 20%);
      border-radius: 5px;
      box-shadow: 0 8px 16px 0 rgba(40,40,90,.09),0 3px 6px 0 rgba(0,0,0,.065);

    }

  }
}


@media (max-width: 1024px) {

}
</style>
